import type { ChecklistItemStatus } from '../../../../../components/checklist';
import { useCustomerGroups } from '../../../../customer-groups';
import { hasAssignedPriceList } from './has-assigned-price-list';

// Complete once any customer group has a price list assigned. Setup doesn't track a specific group —
// it's the existence of one assignment that proves the merchant has wired pricing to a group.
export function useChecklistStatus(): ChecklistItemStatus | undefined {
  const { data, isLoading } = useCustomerGroups();
  if (isLoading) {
    return undefined;
  }
  return data.some(hasAssignedPriceList) ? 'complete' : 'pending';
}
